import type { Translate } from "@smartmanager/shell-ui/shared/i18n/translate";
import { msg } from "@/src/shared/i18n/msg";

/**
 * Error code public forms return when the abuse check refuses an address,
 * and the copy each form shows for it. The contact form and public booking
 * use the same words for the same problem.
 */
export type EmailRejectionCode = "email_disposable";

export const EMAIL_REJECTION_MESSAGES: Record<EmailRejectionCode, string> = {
  email_disposable: msg("Use a permanent email address. Temporary inboxes can’t be used."),
};

export function isEmailRejectionCode(value: unknown): value is EmailRejectionCode {
  return value === "email_disposable";
}

export function emailRejectionMessage(code: unknown, t: Translate): string | null {
  return isEmailRejectionCode(code) ? t(EMAIL_REJECTION_MESSAGES[code]) : null;
}

/**
 * `?error=` codes the signed-out pages (home and desktop entry) explain.
 * `signup_email_not_allowed` comes from the account choke point in
 * `/api/auth/workos`.
 */
const SIGNED_OUT_ERROR_MESSAGES: Record<string, string> = {
  session_failed: msg("Your secure sign-in session could not be verified. Please try signing in again."),
  access_denied: msg("Sign-in was cancelled. No changes were made."),
  provider_error: msg("The sign-in provider could not complete the request. Please try again."),
  signup_email_not_allowed: msg("Smart Manager can’t open an account with that email address. Use a permanent address you check."),
};

export function signedOutErrorMessage(code: string | null, t: Translate): string | null {
  if (!code || !Object.hasOwn(SIGNED_OUT_ERROR_MESSAGES, code)) return null;
  return t(SIGNED_OUT_ERROR_MESSAGES[code]);
}
